module.exports = __webpack_public_path__ + "img/hourglass-end.dbe61fd7.svg";